export const COUNT = 'COUNT'
export const CURRENT_PAGE = 'CURRENT_PAGE'
export const ERROR = 'ERROR'
export const LOADING = 'LOADING'
export const SEARCH = 'SEARCH'
export const TABLE_DATA = 'TABLE_DATA'
export const TABLE_HEAD_LIST = 'TABLE_HEAD_LIST'
